module.exports = __webpack_public_path__ + "static/ef0fdfc5e4b3daafc73b637ea329569ffddead6a729e621d52291a90233cfba8-6c820dea79cd039929c212a266381843.jpeg";